(() => {
if (!('customElements' in window) || customElements.get('dakhli-careers')) return;
customElements.define('dakhli-careers', class extends HTMLElement {
connectedCallback() {
if (this._dkvReady) return;
/* Defer one frame so dynamically inserted Shopify markup is complete. */
this._dkvFrame = requestAnimationFrame(() => this.init());
}
init() {
if (!this.isConnected || this._dkvReady) return;
this._dkvReady = true;
this._dkvAbort = new AbortController();
const opts = { signal: this._dkvAbort.signal };
const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const hero = this.querySelector('[data-dkv-hero]');
const visual = this.querySelector('[data-dkv-visual]');
const stage = this.querySelector('[data-dkv-stage]');
const application = this.querySelector('[data-dkv-panel]');
const steps = Array.from(this.querySelectorAll('[data-dkv-step]'));
let panel = this.querySelector('[data-dkv-step="faq"]');
this._dkvNavigating = false;
const showPanel = (animate, target = panel) => {
const grid = this.querySelector('.dkv-hero-grid');
if (this._dkvExpand) this._dkvExpand.cancel();
const oldHeight = grid ? grid.getBoundingClientRect().height : 0;
steps.forEach(step => { step.hidden = step !== target; });
panel = target;
panel.hidden = false;
if (visual) visual.classList.add('dkv-visual-form');
if (hero) hero.classList.add('dkv-form-open');
if (animate && !reduce()) {
panel.classList.remove('dkv-panel-anim');
void panel.offsetWidth; /* restart the entry animation */
panel.classList.add('dkv-panel-anim');
}
if (animate && !reduce() && grid && typeof grid.animate === 'function') {
const newHeight = grid.getBoundingClientRect().height;
if (Math.abs(newHeight - oldHeight) > 1) {
this._dkvExpand = grid.animate([
{ height: oldHeight + 'px', minHeight: '0px', overflow: 'hidden' },
{ height: newHeight + 'px', minHeight: '0px', overflow: 'hidden' }
], { duration: 520, easing: 'cubic-bezier(.22, 1, .36, 1)' });
return this._dkvExpand.finished.then(() => true, () => false);
}
}
return Promise.resolve(true);
};
const openPanel = (scroll) => {
if (!panel || !panel.hidden) return;
clearTimeout(this._dkvSwap);
if (stage && !reduce()) {
stage.classList.add('dkv-stage-out');
this._dkvSwap = setTimeout(() => {
if (!this.isConnected) return;
stage.hidden = true;
openFirstFaq();
showPanel(true).then(completed => {
if (completed && scroll && this.isConnected && !panel.hidden) {
this.focusPanel(panel, reduce());
}
});
}, 300);
} else {
if (stage) stage.hidden = true;
openFirstFaq();
showPanel(false);
if (scroll) this.focusPanel(panel, true);
}
};
const closePanel = () => {
if (!panel || panel.hidden) return;
clearTimeout(this._dkvSwap);
if (this._dkvExpand) this._dkvExpand.cancel();
if (this._dkvStepExit) this._dkvStepExit.cancel();
this._dkvNavigating = false;
steps.forEach(step => { step.hidden = true; });
panel.classList.remove('dkv-panel-anim');
if (visual) visual.classList.remove('dkv-visual-form');
if (hero) hero.classList.remove('dkv-form-open');
if (stage) {
stage.hidden = false;
void stage.offsetWidth;
stage.classList.remove('dkv-stage-out');
}
panel = this.querySelector('[data-dkv-step="faq"]');
const trigger = this.querySelector('[data-dkv-open]');
if (trigger) trigger.focus({ preventScroll: true });
};
this.querySelectorAll('[data-dkv-open]').forEach(el => {
el.addEventListener('click', event => {
if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
event.preventDefault();
openPanel(true);
}, opts);
});
this.querySelectorAll('[data-dkv-close]').forEach(el => {
el.addEventListener('click', closePanel, opts);
});
this.addEventListener('keydown', event => {
if (event.key === 'Escape' && panel && !panel.hidden) closePanel();
}, opts);
const navigate = async name => {
if (this._dkvNavigating || panel.hidden) return;
const target = steps.find(step => step.dataset.dkvStep === name);
if (!target || target === panel) return;
this._dkvNavigating = true;
if (!reduce() && typeof panel.animate === 'function') {
this._dkvStepExit = panel.animate([
{ opacity: 1, transform: 'translateY(0)' },
{ opacity: 0, transform: 'translateY(14px)' }
], { duration: 180, easing: 'ease-in', fill: 'forwards' });
const completed = await this._dkvStepExit.finished.then(() => true, () => false);
if (!completed || !this.isConnected || panel.hidden) return;
}
if (this._dkvStepExit) this._dkvStepExit.cancel();
if (name === 'faq') openFirstFaq();
const completed = await showPanel(true, target);
this._dkvNavigating = false;
if (completed && this.isConnected && !target.hidden) this.focusPanel(target, reduce());
};
this.querySelectorAll('[data-dkv-go]').forEach(button => {
button.addEventListener('click', () => navigate(button.dataset.dkvGo), opts);
});
/* Shopify's own form posts normally; a custom endpoint posts in place so the
   CV file can travel with it. */
const contactForm = this.querySelector('.dkv-form');
const formError = this.querySelector('[data-dkv-form-error]');
if (contactForm && contactForm.hasAttribute('data-dkv-ajax')) contactForm.addEventListener('submit', async event => {
event.preventDefault();
if (contactForm.dataset.dkvBusy || !contactForm.reportValidity()) return;
contactForm.dataset.dkvBusy = 'true';
const button = contactForm.querySelector('.dkv-submit');
if (button) button.disabled = true;
if (formError) formError.hidden = true;
try {
const body = new FormData(contactForm);
/* The endpoint takes text only, so the CV goes to storage first and travels as a link. */
const fileInput = contactForm.querySelector('input[type="file"]');
const file = fileInput && fileInput.files && fileInput.files[0];
if (file && fileInput.name) {
body.delete(fileInput.name);
const cloud = contactForm.dataset.dkvCloud;
const preset = contactForm.dataset.dkvPreset;
if (!cloud || !preset) {
throw new Error('Cloudinary cloud name or upload preset is missing in the section settings.');
}
{
const upload = new FormData();
upload.append('file', file);
upload.append('upload_preset', preset);
if (contactForm.dataset.dkvFolder) upload.append('folder', contactForm.dataset.dkvFolder);
/* raw, not image: documents deliver without Cloudinary's PDF restriction. */
const stored = await fetch('https://api.cloudinary.com/v1_1/' + cloud + '/raw/upload', { method: 'POST', body: upload });
let storedData = null;
try { storedData = await stored.json(); } catch (parseError) { /* response was not JSON */ }
if (!stored.ok || !storedData || !storedData.secure_url) {
throw new Error((storedData && storedData.error && storedData.error.message) || 'CV upload failed');
}
/* fl_attachment downloads the file instead of opening it in the PDF viewer. */
const stored_url = String(storedData.secure_url);
const download = stored_url.indexOf('/raw/upload/') > -1
? stored_url.replace('/raw/upload/', '/raw/upload/fl_attachment/')
: stored_url;
body.append(fileInput.name, download);
body.append('File Name', file.name);
}
}
const response = await fetch(contactForm.action, {
method: 'POST',
body,
headers: { 'Accept': 'application/json' }
});
let payload = null;
try { payload = await response.json(); } catch (parseError) { /* response was not JSON */ }
if (!response.ok || (payload && payload.success === false)) {
let detail = '';
if (payload) {
if (Array.isArray(payload.errors)) detail = payload.errors.map(item => item.message).join('. ');
else if (payload.message) detail = payload.message;
else if (payload.error) detail = payload.error;
}
throw new Error(detail || ('HTTP ' + response.status));
}
contactForm.reset();
const fileName = contactForm.querySelector('[data-dkv-file]');
if (fileName) { fileName.hidden = true; fileName.textContent = ''; }
navigate('confirmation');
} catch (error) {
console.error('[dakhli-careers]', error);
const detail = this.querySelector('[data-dkv-form-detail]');
if (detail) {
detail.textContent = error.message || '';
detail.hidden = !detail.textContent;
}
if (formError) formError.hidden = false;
} finally {
delete contactForm.dataset.dkvBusy;
if (button) button.disabled = false;
}
}, opts);
const faqItems = Array.from(this.querySelectorAll('[data-dkv-faq-item]'));
const setFaq = (item, open) => {
cancelAnimationFrame(item._dkvTypeFrame);
item.classList.toggle('is-open', open);
item.querySelector('.dkv-faq-q').setAttribute('aria-expanded', String(open));
item.querySelector('.dkv-faq-a').setAttribute('aria-hidden', String(!open));
if (!open) return;
const text = item.querySelector('.dkv-faq-text');
if (!text.dataset.prepared) {
const original = text.textContent;
const accessible = document.createElement('span');
accessible.className = 'dkv-sr';
accessible.textContent = original;
const visualText = document.createElement('span');
visualText.setAttribute('aria-hidden', 'true');
Array.from(original).forEach(character => {
const span = document.createElement('span');
span.className = 'dkv-char';
span.textContent = character;
visualText.appendChild(span);
});
text.replaceChildren(accessible, visualText);
text.dataset.prepared = 'true';
}
const chars = Array.from(text.querySelectorAll('.dkv-char'));
chars.forEach(char => char.classList.toggle('is-on', reduce()));
if (reduce()) return;
let start, shown = 0;
const type = time => {
if (!this.isConnected || !item.classList.contains('is-open')) return;
if (start === undefined) start = time;
const count = Math.min(chars.length, Math.floor((time - start) / 8) + 1);
while (shown < count) chars[shown++].classList.add('is-on');
if (shown < chars.length) item._dkvTypeFrame = requestAnimationFrame(type);
};
item._dkvTypeFrame = requestAnimationFrame(type);
};
/* The first question opens by itself whenever the step becomes visible. */
const openFirstFaq = () => {
if (!faqItems.length) return;
faqItems.forEach((item, index) => setFaq(item, index === 0));
};
/* One answer is open at a time, so the final layout is known before it animates. */
const settleFaq = (item, previous) => {
const question = item.querySelector('.dkv-faq-q');
const answer = item.querySelector('.dkv-faq-text');
const grow = answer ? answer.getBoundingClientRect().height : 0;
let shift = 0;
if (previous && previous !== item && (previous.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING)) {
const closing = previous.querySelector('.dkv-faq-text');
shift = closing ? -closing.getBoundingClientRect().height : 0;
}
const rect = question.getBoundingClientRect();
const overflow = rect.bottom + shift + grow - (window.innerHeight - 24);
const headroom = rect.top + shift - 90;
const move = Math.min(overflow, headroom);
if (move <= 2) return;
window.scrollBy({ top: move, behavior: reduce() ? 'auto' : 'smooth' });
};
faqItems.forEach(item => item.querySelector('.dkv-faq-q').addEventListener('click', () => {
const open = !item.classList.contains('is-open');
const previous = faqItems.find(other => other !== item && other.classList.contains('is-open')) || null;
faqItems.forEach(other => { if (other !== item) setFaq(other, false); });
setFaq(item, open);
if (open) settleFaq(item, previous);
}, opts));
/* Phone: Georgian prefix, 3-3-3 grouping, nine digits maximum. */
const phoneInput = this.querySelector('[data-dkv-phone]');
if (phoneInput) {
const prefix = phoneInput.parentElement.querySelector('.dkv-prefix');
const syncPad = () => {
const width = prefix ? prefix.getBoundingClientRect().width : 0;
if (width) phoneInput.style.setProperty('--dkv-phone-pad', Math.round(width + 23) + 'px');
};
const format = () => {
const caret = phoneInput.selectionStart;
const kept = phoneInput.value.slice(0, caret).replace(/\D/g, '').length;
const digits = phoneInput.value.replace(/\D/g, '').slice(0, 9);
const value = digits.replace(/(\d{3})(?=\d)/g, '$1 ');
if (value !== phoneInput.value) phoneInput.value = value;
let index = 0, seen = 0;
while (index < value.length && seen < kept) {
if (value[index] >= '0' && value[index] <= '9') seen++;
index++;
}
try { phoneInput.setSelectionRange(index, index); } catch (error) { /* unsupported input type */ }
};
phoneInput.addEventListener('focus', syncPad, opts);
phoneInput.addEventListener('input', format, opts);
phoneInput.addEventListener('paste', () => requestAnimationFrame(format), opts);
}
/* File picker: name preview, 50MB ceiling and drag styling. */
const drop = this.querySelector('[data-dkv-drop]');
if (drop) {
const input = drop.querySelector('input[type="file"]');
const name = drop.querySelector('[data-dkv-file]');
const showName = () => {
const file = input.files && input.files[0];
const limit = Number(input.dataset.dkvMax) || Infinity;
if (file && file.size > limit) {
input.value = '';
name.hidden = false;
name.classList.add('dkv-invalid');
name.textContent = input.dataset.dkvToobig || 'File is too large';
return;
}
name.hidden = !file;
name.classList.remove('dkv-invalid');
name.textContent = file ? file.name : '';
};
input.addEventListener('change', showName, opts);
['dragenter', 'dragover'].forEach(type => {
drop.addEventListener(type, event => {
event.preventDefault();
drop.classList.add('dkv-drag');
}, opts);
});
['dragleave', 'dragend', 'drop'].forEach(type => {
drop.addEventListener(type, () => drop.classList.remove('dkv-drag'), opts);
});
drop.addEventListener('drop', event => {
event.preventDefault();
if (!event.dataTransfer || !event.dataTransfer.files.length) return;
input.files = event.dataTransfer.files;
showName();
}, opts);
}
const photo = this.querySelector('.dkv-photo');
const photoError = () => {
photo.hidden = true;
this.querySelector('.dkv-photo-fallback').hidden = false;
};
if (photo) {
photo.addEventListener('error', photoError, opts);
if (photo.complete && !photo.naturalWidth) photoError();
}
/* After a normal post the page reloads: reopen the step the visitor left off at. */
const confirmation = this.querySelector('[data-dkv-step="confirmation"]');
const serverError = this.querySelector('[data-dkv-server-error]');
if (serverError && application) {
if (stage) stage.hidden = true;
showPanel(false, application);
this.focusPanel(application, true);
} else if (confirmation && new URLSearchParams(location.search).get('contact_posted') === 'true') {
if (stage) stage.hidden = true;
showPanel(false, confirmation);
this.focusPanel(confirmation, true);
} else if (application && location.hash === '#' + application.id) {
if (stage) stage.hidden = true;
showPanel(false, application);
} else if (panel && location.hash === '#' + panel.id) {
if (stage) stage.hidden = true;
openFirstFaq();
showPanel(false);
}
/* Content stays visible if JavaScript or animation APIs are unavailable. */
if (!reduce() && 'IntersectionObserver' in window && Element.prototype.animate) {
this._dkvObserver = new IntersectionObserver(entries => {
entries.forEach(entry => {
if (!entry.isIntersecting) return;
entry.target.animate([
{ opacity: .35, transform: 'translateY(18px)' },
{ opacity: 1, transform: 'translateY(0)' }
], { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)' });
this._dkvObserver.unobserve(entry.target);
});
}, { threshold: .08 });
this.querySelectorAll('[data-dkv-reveal]').forEach(el => this._dkvObserver.observe(el));
}
}
focusPanel(panel, instant) {
cancelAnimationFrame(this._dkvScrollFrame);
/* Focus the panel, not an input: avoid opening the mobile keyboard. */
panel.focus({ preventScroll: true });
this._dkvScrollFrame = requestAnimationFrame(() => {
if (!this.isConnected || panel.hidden) return;
panel.scrollIntoView({
behavior: instant ? 'instant' : 'smooth',
block: 'start',
inline: 'nearest'
});
});
}
disconnectedCallback() {
if (this._dkvStepExit) this._dkvStepExit.cancel();
this.querySelectorAll('[data-dkv-faq-item]').forEach(item => cancelAnimationFrame(item._dkvTypeFrame));
cancelAnimationFrame(this._dkvFrame);
cancelAnimationFrame(this._dkvScrollFrame);
if (this._dkvExpand) this._dkvExpand.cancel();
clearTimeout(this._dkvSwap);
if (this._dkvAbort) this._dkvAbort.abort();
if (this._dkvObserver) this._dkvObserver.disconnect();
this._dkvReady = false;
}
});
})();